import React, { FC, useState } from 'react';
import { ACCESS_UNTIL, EMAIL, ENTER_EMAIL, ENTER_NAME, MEMBERSHIP_TYPE, NAME } from '../../utils/constants/labels';
import { DatePicker, Form, Input, Radio } from 'antd';
import { FormProps } from 'antd/lib/form';

type Props = FormProps;

const InviteUserForm: FC<Props> = props => {
  const [membership, setMembership] = useState('LIFETIME');

  return (
    <Form {...props} initialValues={{ email: '', name: '' }}>
      <Form.Item name="email" label={EMAIL} rules={[{ required: true, type: 'email' }]}>
        <Input type={'email'} placeholder={ENTER_EMAIL} />
      </Form.Item>
      <Form.Item name="name" label={NAME} rules={[{ required: true }]}>
        <Input placeholder={ENTER_NAME} />
      </Form.Item>
      <Form.Item name="membership" label={MEMBERSHIP_TYPE}>
        <Radio.Group onChange={e => setMembership(e.target.value)} value={membership}>
          <Radio value={'LIFETIME'}>Lifetime</Radio>
          <Radio value={'DEMO'}>Demo</Radio>
        </Radio.Group>
      </Form.Item>
      {membership === 'DEMO' && (
        <Form.Item name="accessUntil" label={ACCESS_UNTIL} rules={[{ required: true }]}>
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
      )}
    </Form>
  );
};

export default InviteUserForm;
